import React from "react";
import PropTypes from "prop-types";
import { LuSearch, LuX } from "react-icons/lu";
import "./_panelSearch.scss";

// Search field with a leading icon and an inline clear (×) shown only when there is text.
const PanelSearch = ({ value, onChange, onClear, onEnter, placeholder, autoFocus }) => (
  <div className="cmp-search">
    <LuSearch className="cmp-search__icon" size={16} />
    <input
      className="cmp-search__input"
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={onEnter ? (e) => e.key === "Enter" && onEnter() : undefined}
      placeholder={placeholder}
      autoFocus={autoFocus}
    />
    {value ? (
      <button
        type="button"
        className="cmp-search__clear"
        aria-label="Clear search"
        onClick={onClear}
      >
        <LuX size={12} />
      </button>
    ) : null}
  </div>
);

PanelSearch.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
};

export default PanelSearch;
